module.exports = __webpack_public_path__ + "img/wine.64032740.png";